import { Action } from '@ngrx/store';

export function addSuccessType<TModel>(module: string, type: { new(): TModel;}):string
{
  return `[${module}] Add ${(type as any).$typeName} Success`;
}

export class AddSuccessAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { key: string }) {
    this.type = addSuccessType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/AddSuccessAction.ts